import { Component, ElementRef, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { DemoService } from './../../../../demo.service';
import { FileUploaderService } from './../../../../services/file-uploader-service';
import { GlobalFunctionsService } from './../../../../services/global-functions.service';
import { MysqlService } from './../../../../services/mysql.service';
import { JobSubject } from './../../../../shared/models/jobSubject.model';

// import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap';
import { HotToastComponent } from '@ngneat/hot-toast/lib/components/hot-toast/hot-toast.component';
import { HotToastModule, HotToastService } from '@ngneat/hot-toast';
import { AppRoute } from 'src/app/shared/models/appRoute.model';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-subject-card-layouts-dashboard',
  templateUrl: './subject-card-layouts-dashboard.component.html',
  styleUrls: ['./subject-card-layouts-dashboard.component.scss']
})
export class SubjectCardLayoutsDashboardComponent implements OnInit {

  sessionUserId: any;
  nav: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  subject_id: number;
  subject: any;
  job_id: any;
  file_number: any;
  subject_number: any;
  job_type_id: any;
  job_type_location_id: any;
  job_type_court_id: any;
  job_type_document_type_id: any;
  job_type_affidavit_type_id: any;
  model: JobSubject;
  subject_progress: any;
  DialogObj: any;
  allAgents: any;
  assignedAgentsList: any;
  agent_associated: number;

  // layouts panels settings dashbards

  @ViewChild("videoPlayer", { static: false }) videoplayer: ElementRef;
  isPlay: boolean = false;
  video_name: string;

  isShow_route_diagram = false;
  isShow_route_diagram_hierarchial = false;

public cellSpacing: number[] = [1, 1];
public mediaQuery: string = 'max-width: 700px';
public panels: any = [
{ "sizeX": 1, "sizeY": 1, "row": 0, "col": 0, content: '<div class="content">0</div>' },
{ "sizeX": 3, "sizeY": 2, "row": 0, "col": 1, content: '<div class="content">1</div>' },
{ "sizeX": 1, "sizeY": 3, "row": 0, "col": 4, content: '<div class="content">2</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 1, "col": 0, content: '<div class="content">3</div>' },
{ "sizeX": 2, "sizeY": 1, "row": 2, "col": 0, content: '<div class="content">4</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 2, "col": 2, content: '<div class="content">5</div>' },
{ "sizeX": 1, "sizeY": 1, "row": 2, "col": 3, content: '<div class="content">6</div>' }
]
public allowResizing: boolean = true;
public resizableHandles: string[] = ['e-south-east','e-east','e-west','e-north','e-south'];
  app_route_all_UTH_count: any;
  search_model_UTH_panel: AppRoute;
  app_routes_metrix_search_all_UTH_panel_results: any;
  new_data_all_UTH_panel: any;
  app_route_all_UTH_panel: any;
  app_route_all_panel_UTH_count: any;
  app_route_related_count: any;
  app_routes_metrix_search_all_UTH_panel: Object;
  app_routes_metrix_search_all_UTH_panelTaskDone: Object;
  app_routes_metrix_search_all_UTH_panel_task_done_results: any;
  new_data_all_UTH_panel_task_done: any;
  app_route_all_UTH_panel_task_done: any;
  app_route_all_panel_UTH_count_task_done: any;
  modalRef: any;


  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }

  constructor(
    private _demoService: DemoService,
    private route: ActivatedRoute,
     vcr: ViewContainerRef, private router: Router,
     private fileUploader: FileUploaderService,
     private _mysqlService: MysqlService,
     private modalService: BsModalService,
     public gfunc: GlobalFunctionsService,
     public toastr: HotToastService,
     private sanitizer: DomSanitizer,
  ) {

    this.nav = document.querySelector('nav.navbar');
    // this.toastr.setRootViewContainerRef(vcr);

  // login vars
// Set and Access login Session Variables
this.gfunc.setLoginSessionVars(); // set in a global function file
this.sessionUserId = this.gfunc.currentUserVAR.user_id;
this.sessionUsername = this.gfunc.currentUserVAR.username;
this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

     // need to add this as routes does not work globally
     this.all_router_details = this.router.url;
     this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

  this.subject_id = +this.route.snapshot.paramMap.get('subject_id');

 

   }

  ngOnInit() {

    if (this.gfunc.sessionUserLevel == 5){
      this.getSubjectAgentBrandsAssigned(this.subject_id);
      }


    this.model = new JobSubject;
    this.getJobSubject(this.subject_id);

  }




  getJobSubject(subject_id) {
    this._demoService.getJobSubject(subject_id).subscribe(
       data => { this.subject = data;
        const res = data[0];

        this.job_id = res.job_id;
        this.file_number = res.file_number;
        this.subject_number = res.subject_number;

        this.job_type_id = res.job_type_id;
        this.job_type_location_id = res.job_type_location_id;
        this.job_type_court_id = res.job_type_court_id;
        this.job_type_document_type_id = res.job_type_document_type_id;
        this.job_type_affidavit_type_id = res.job_type_affidavit_type_id;



//:: test to load these after the data is returned true or false;

            //   // this.getSubjectNotes(res.subject_id);
            //   // load subject history
              this.getSubjectProgress(this.job_id, this.file_number);

            // // get job type in relation to subject
            //  this.getJobType(this.job_type_id);
            //  this.getJobTypeLocation(this.job_type_location_id);
            //  this.getJobTypeCourt(this.job_type_court_id);
            //  this.getJobTypeDocument(this.job_type_document_type_id);
            //  this.getJobTypeAffidavit(this.job_type_affidavit_type_id);

            //  this.getJobSubjects(this.job_id); // total subjects of job count to hide delete if one left.

// this.getSubjectNotesProgressionTable(res.job_id, res.file_number, this.model )
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );

   } // end function




   getSubjectProgress(job_id, file_number){
    this._demoService.getSubjectProgress(job_id, file_number).subscribe(
      data => { this.subject_progress = data;
        let res = data[0];
        
        // this.load_me_last = 1;
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
    }



    // custom dialog

public onOpenDialogNewStage = function(event: any, filename, model): void {
  this.DialogObj = DialogUtility.confirm({
  title: 'Create New Subject Stage',
  content: 'Create a new subject stage from this existing subject details',
  okButton: { text: 'Generate New Subject', click: this.okNewStageClick.bind(this, filename, model) },
  cancelButton: {  text: 'Cancel', click: this.cancelNewStageClick.bind(this) },
  showCloseIcon: true,
  closeOnEscape: true,
  animationSettings: { effect: 'Zoom' }
});
}
public okNewStageClick(this, filename, model): void {
//  alert('you clicked OK button');
// run save file option
// this.saveBothTemplate(filename, model);
console.log('SubjectID: ' + model.subject_id);
this.newSubjectReference(model);
this.DialogObj.hide();
}

public cancelNewStageClick(): void {
// alert('you clicked Cancel button');
this.DialogObj.hide();
};



// Mussing Function


// this reports as failes but actually works.

newSubjectReference(model){
  this._demoService.newSubjectReference(model).subscribe(
    data => { // this.new_subject_data = data; // this is the retuned json upon creation.
    this.toastr.success('New Subject Reference Data Entered');
    // API Updated to return JSON of last inserted ID: {"last_insert_id" : "232"}

     // Setup annd the Currents before we redirec the page
     // Needs to be a Function to update the ObserveOnOperator.
     // this.newCTrace_id(this.latest_trace_id);
     // or this.cdata.changeCTrace_id("999");

   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);

  this.gfunc.insertLog_UpdateSubjectNewStage(model); 
    // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
    // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
       return true;


    },
    error => {
    // console.log('Should be form Model' + model);
    // console.error('Error Creating a Trace Project!');
   //  this.toastr.error('Adding Subject Reference Failed :: Please try again!');
   // this.router.navigate(['/admin/jobs/view/' + model.job_id + '']);
  //  this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
  //  this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
    this.gfunc.globalJobSubjectViewSkipRoute(model.subject_id);
     // console.log(Observable.throw(error));
     // return Observable.throw(error);
    }
);


};



// need to get all associated agents of the job and push thier information to array
getSubjectAgentBrandsAssigned(subject_id) {
  console.log('Running Subject Agent Access Checker!!! 101');
    this.allAgents = [];
    this._demoService.getSubjectAgentBrandsAssigned(subject_id).subscribe(
       data => { 
         this.assignedAgentsList = data;
        //  let res = data[0];
         let newArr = data;
         let  count_of_items = Object.keys(newArr).length;
           // need to do a loop of subject_billing items (.length)
           this.agent_associated = 0;
  
           let array = [];
           let ata_array = [];
           let array_length;
  
           for(let i=0;i < count_of_items; i++) {
           let res = newArr[i];
  
           this.allAgents.push({
             recipient_name: res.name + '',
             recipient_email_address: res.email,
             recipient_brand_id: res.brand_id,
             recipient_subject_id: res.subject_id,
             recipient_brand_type_id: res.brand_type_id,
             recipient_user_id: null,
             recipient_user_level_id: null,
             recipient_type_name: 'Agent',
           });
           } // end for loop
        //  this.allAgents = this.allAgents; // ?? this may be causing errors.
         // set records to send to subject_notes data table
        //  this.model.assigned_to_agents = JSON.stringify(this.allRecipients);
  
              // array = res.assigned_to_agents;
    array = JSON.parse(this.allAgents);
    // console.log('array: ', array);
        
    ata_array = array.filter( (n: any) => (
            n.recipient_brand_id === this.gfunc.sessionBrandId
            // n.note_id >= '200'
            // && sbi.subject_id === this.subject_service_metrix_search_full_results[i].subject_id
            ));
            console.log('ata_array.lenght: ', ata_array.length);
           
           // does the check and decides if to display page or note
            array_length = ata_array.length;
            if (ata_array.length >= 1) {
              this.agent_associated = 1;
            };
            
            if (ata_array.length === 0) {
             this.agent_associated = 0;
            }
            // console.log('Agent Associated: ', this.agent_associated);
  
      },
       err => console.error(err),
       // () => console.log('Loaded Assigned Agents Loaded.')
     );
   }




// MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // this.modalRef = this.modalService.show(template);
      // small upgrade to disable background click on open modal background
      const config = { backdrop: true, ignoreBackdropClick: false, class: 'gray modal-lg' };
      this.modalRef = this.modalService.show(template, config);
}

// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
  this.modalRef.hide();
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
};

  // ::@https://stackblitz.com/edit/angular-bmxbmy?file=src%2Fapp%2Fapp.component.html
  getHtml(html){
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

    // ::@https://stackoverflow.com/questions/29369512/render-html-entities-string-in-html-with-angular properway to do it (decode html special charactors for dispaly)
  // WORKS as I created my own function from this articel == pretty well convers
  transform2(value: any, args?: any): any {
    const doc = new DOMParser().parseFromString(value, 'text/html');
    return doc.documentElement.textContent;
  }






}
